module.exports = __webpack_public_path__ + "img/upload.49dd7814.png";